import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder, formBuilderParams } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.employees.";
const FORM_LABEL_KEY = `${PAGE_LOCALE_KEY}employeeDetail.config.fields`;

const EmployeeDeveloperConfig = ({ formProps }) => {
  const { t } = useTranslation();

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    testGp: {
      fieldType: "checkbox",
      fieldName: "testGp",
      label: t(`${FORM_LABEL_KEY}.testGp`),
    },
    debugStripTag91: {
      fieldType: "checkbox",
      fieldName: "debugStripTag91",
      label: t(`${FORM_LABEL_KEY}.debugStripTag91`),
    },
    autoReversalEnabled: {
      fieldType: "checkbox",
      fieldName: "autoReversalEnabled",
      label: t(`${FORM_LABEL_KEY}.autoReversalEnabled`),
    },
    shortPollEnabled: {
      fieldType: "checkbox",
      fieldName: "shortPollEnabled",
      label: t(`${FORM_LABEL_KEY}.shortPollEnabled`),
    },
    earlyReplyHttp: {
      fieldType: "checkbox",
      fieldName: "earlyReplyHttp",
      label: t(`${FORM_LABEL_KEY}.earlyReplyHttp`),
    },
    debugExtraLog: {
      fieldType: "checkbox",
      fieldName: "debugExtraLog",
      label: t(`${FORM_LABEL_KEY}.debugExtraLog`),
    },
    debugDisableLocalExpiryCheck: {
      fieldType: "checkbox",
      fieldName: "debugDisableLocalExpiryCheck",
      label: t(`${FORM_LABEL_KEY}.debugDisableLocalExpiryCheck`),
    },
    checkKsnRepeat: {
      fieldType: "checkbox",
      fieldName: "checkKsnRepeat",
      label: t(`${FORM_LABEL_KEY}.checkKsnRepeat`),
    },
    checkInvoice: {
      fieldType: "checkbox",
      fieldName: "checkInvoice",
      label: t(`${FORM_LABEL_KEY}.checkInvoice`),
    },
    optCheckForegroundRunning: {
      fieldType: "checkbox",
      fieldName: "optCheckForegroundRunning",
      label: t(`${FORM_LABEL_KEY}.optCheckForegroundRunning`),
    },
    optReceiptLogo: {
      fieldType: "checkbox",
      fieldName: "optReceiptLogo",
      label: t(`${FORM_LABEL_KEY}.optReceiptLogo`),
    },
    optTmsCache: {
      fieldType: "checkbox",
      fieldName: "optTmsCache",
      label: t(`${FORM_LABEL_KEY}.optTmsCache`),
    },
    optUploadLog: {
      fieldType: "checkbox",
      fieldName: "optUploadLog",
      label: t(`${FORM_LABEL_KEY}.optUploadLog`),
    }
  };

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.developerOption`)}
      titleVariant="h3"
      padding={formBuilderParams.formSectionLeftPadding}>
      <FormBuilder.Row itemsPerRow={3}>
        {FormBuilder.buildFields({
          formProps, fields: [
            // fieldsConfig.testGp,
            fieldsConfig.debugStripTag91,
            // fieldsConfig.autoReversalEnabled,
            // fieldsConfig.shortPollEnabled,
            // fieldsConfig.earlyReplyHttp,
            // fieldsConfig.debugExtraLog,
            fieldsConfig.debugDisableLocalExpiryCheck,
            fieldsConfig.checkKsnRepeat,
            // fieldsConfig.checkInvoice,
            // fieldsConfig.optCheckForegroundRunning,
            // fieldsConfig.optReceiptLogo,
            // fieldsConfig.optTmsCache,
            fieldsConfig.optUploadLog
          ]
        })}
      </FormBuilder.Row>
    </FormBuilder.Section>
  );
};

export default React.memo(EmployeeDeveloperConfig);
